import { PAYMENT_METHOD_TYPES } from '../enum/api/paymentTypes';

export const isPaymentMethodDisabled = (
  method,
  totalAmountWithCreditCard,
  totalAmountWithoutCreditCard,
  isAccountBalanceDisabled,
) =>
  (method?.PaymentMethodType === PAYMENT_METHOD_TYPES.ACH &&
    method?.BankAccountSetupType === 2) ||
  (method?.PaymentMethodType === PAYMENT_METHOD_TYPES.CREDIT_CARD &&
    method?.CreditCardIsExpired) ||
  (method?.PaymentMethodType === PAYMENT_METHOD_TYPES.ACH &&
    totalAmountWithoutCreditCard > method?.MaximumLimit) ||
  (method?.PaymentMethodType === PAYMENT_METHOD_TYPES.CREDIT_CARD &&
    totalAmountWithCreditCard > method?.MaximumLimit) ||
  (method?.PaymentMethodType === PAYMENT_METHOD_TYPES.ACCOUNT_BALANCE &&
    isAccountBalanceDisabled);
